import { type FeedbackMetadata } from './types';

/**
 * Formats the body of the feedback description to include a text-based message along with a JSON payload to
 * embed as a raw JSON value below the message.
 */
export const formatFeedbackTextWithMetadata = ({
	message,
	metadata,
}: {
	message: string;
	metadata?: FeedbackMetadata;
}): string => {
	if (!metadata) {
		return message;
	}

	return `${message}

\`\`\`
${JSON.stringify(metadata, null, 2)}
\`\`\`
`;
};
